// Rodolfo Rivas
// 2017
// *************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
// *************************************************************//


import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import * as moment from 'moment';
import {BsDatepickerConfig, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {FormGroup} from '@angular/forms';

import {MatSnackBar} from '@angular/material';
import {Ng2DeviceService} from 'ng2-device-detector';
import {AmazingTimePickerService} from 'amazing-time-picker';
import {ConsumerService} from "../../../../recursos/servicio/consumer.service";
import {Emisor} from "../../../seguridad/emisor/recursos/modelo/emisor";
import {LayoutService} from "../../../../recursos/servicio/layout.service";
import {UtilConfig} from "../../../../../autenticacion/servicios/UtilConfig";
import {Lote} from "./recursos/modelo/Lote";
import {WebServices} from "../../../../recursos/modelo/consumerModel/web-services.enum";
import {CustomUrlSerializer} from "../../../../recursos/modelo/UrlSerializer/custom-url-serializer";

declare var swal: any;

declare const $: any;


@Component({
    moduleId: module.id,
    selector: 'app-logTmp',
    templateUrl: './view/listDocuments.component.html',
    styleUrls: ['./css/listDocuments.component.scss'],
    providers: [ConsumerService]
})
export class ListDocumentsComponent implements OnInit, OnChanges {
    // ITEM DEL CRUD
    origenCRUD = 'documento';

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─
    // variables de pantalla
    filtroList = {
        rucReceptor: 'TODAS',
        estadoCPE: 'TODAS',
        tipoFecha: 'SUBIDA'
    };
    type: string = '';
    mensaje = '<i class=\'material-icons\'>search</i> REALICE SU BUSQUEDA UTILIZANDO LOS FILTROS';
    loading = false;
    noHayResultados = false;
    es;
    to = '0';
    max = '9999999';
    filtro = false;
    cargandoConsulta = false;
    cargandoList = false;
    form: FormGroup;
    emisor: Emisor = new Emisor();
    empresaAdministradora = false;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_LOTE_TERCERO_LISTAR: false,
        ROLE_LOTE_TERCERO_LISTAR_TODOS: false,
        ROLE_LOTE_TERCERO_CONSULTAR: false,
        ROLE_LOTE_TERCERO_GENERAR: false,
        ROLE_LOTE_TERCERO_LEVEL_2: false,
    };
    //variables modelo
    ItemLista: Lote[];
    rangeDates: Date[] = [new Date(), new Date()];
    locale = 'es';
    colorTheme = 'theme-dark-blue';
    bsConfig: Partial<BsDatepickerConfig>;
    // scroll list
    inicial = true;
    selectedMovil = false;
    init = true;
    receptores: any[];
    private colorText = null;
    private colorTitle = null;


    constructor(private consumer: ConsumerService,
                private route: ActivatedRoute,
                private router: Router,
                private layout: LayoutService,
                private snackBar: MatSnackBar,
                public jwtUtil: UtilConfig,
                private _localeService: BsLocaleService,
                private deviceService: Ng2DeviceService,
                private atp: AmazingTimePickerService) {

        this._localeService.use(this.locale);
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        this.emisor = jwtUtil.getCurrentUser().customer;


        this.ItemLista = [];

        this.bsConfig = Object.assign({}, {
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            dateInputFormat: 'DD/MM/YYYY'
        });

        this.rangeDates = [new Date(), new Date()];
        this.es = jwtUtil.CONFIG_ES_CALENDAR;


        // SI LA EMPRESA ES ESCON SE HABILITAN LOS SELECT
        if (this.emisor.id == parseInt(jwtUtil.ESCON_CUSTOMER))
            this.empresaAdministradora = true;


        // VERIFICA LOS PERMISOS DEL LOG LOGEADO
        if (this.authorities.ROLE_LOTE_TERCERO_LISTAR) {
            if (CustomUrlSerializer.decript(this.router.url).indexOf('ELECTRONIC') != -1) {
                this.type = 'ELECTRONIC';
            } else {
                this.type = 'PHYSICAL';
            }
            this.route.params.subscribe(params => {

                if (params['rucReceptor']) {
                    this.filtroList.rucReceptor = params['rucReceptor'];
                }

                // RANGO FECHA
                this.filtroList.tipoFecha = params['tipoFecha'] || 'EMISION';
                if (params['inicio']) {
                    this.rangeDates[0] = new Date(params['inicio']);
                }
                if (params['fin']) {
                    this.rangeDates[1] = new Date(params['fin']);
                }

                if (params['inicial']) {
                    this.inicial = false;
                }
                if (params['search'] === '1') {
                    this.init = false;
                    this.realizarBusqueda();
                }
            });
        }
        if (this.jwtUtil.getColorText()) {
            this.colorText = this.jwtUtil.getColorText();
        }
        this.layout.getColorText().subscribe(colorText => {
            this.colorText = colorText;
        });

        if (this.jwtUtil.getColorTitle()) {
            this.colorTitle = this.jwtUtil.getColorTitle();
        }
        this.layout.getColorTitle().subscribe(colorTitle => {
            this.colorTitle = colorTitle;
        });
    }

    ngOnChanges(changes: SimpleChanges) {

        if (this.jwtUtil.getColorTitle()) {
            this.colorTitle = this.jwtUtil.getColorTitle();
        }

        if (this.jwtUtil.getColorText()) {
            this.colorText = this.jwtUtil.getColorText();
        }
    }

    ngOnInit() {
        if (this.emisor.id == parseInt(this.jwtUtil.ESCON_CUSTOMER)) {
            this.getReceptores();
        }
        if (this.deviceService.isMobile() || this.deviceService.isTablet())
            this.selectedMovil = true;

    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴


    refrescar() {
        this.realizarBusqueda();
    }

    listar() {
        const filtro: any = {};
        if (this.filtroList.rucReceptor != '') {
            filtro.rucReceptor = this.filtroList.rucReceptor;
        }

        // RANGO FECHA
        filtro.tipoFecha = this.filtroList.tipoFecha;
        filtro.inicio = moment(this.rangeDates[0]).format('MM/DD/YYYY');
        filtro.fin = moment(this.rangeDates[1]).format('MM/DD/YYYY');

        filtro.inicial = false;

        filtro.ps = new Date().getTime();
        filtro.search = '1';
        this.router.navigate(['/content', {outlets: {'second': ['listDocumentThrids', this.type, filtro]}}]);
    }


    cambiarFecha(tipo) {
        this.filtroList.tipoFecha = tipo;
        this.listar();
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘
    private realizarBusqueda() {
        // LLAMADO AL SERVICIO
        $('ul#slide-out').removeClass('open');
        $('i.cerrarAleta').removeClass('open');
        this.cargandoList = true;
        const params: any = {
            receiverId: 0,
            fechaDesde: moment(this.rangeDates[0]).format('YYYY-MM-DD'),
            fechaHasta: moment(this.rangeDates[1]).format('YYYY-MM-DD'),
            rowType: this.type
        };

        if ((this.filtroList.estadoCPE != 'TODAS')) {
            params.status = this.filtroList.estadoCPE;
        }
        if ((this.filtroList.rucReceptor != 'TODAS')) {
            params.receiverId = parseInt(this.filtroList.rucReceptor);
        }
        if (!this.empresaAdministradora) {
            params.receiverId = this.emisor.id;
        }

        this.ItemLista = [];
        this.consumer.post<any>(WebServices.URL_LIST_LOG_EMISOR_TERCERO, params)
            .subscribe(result => {
                this.cargandoList = false;
                this.ItemLista = result['preloadedLots'];
                sessionStorage.setItem('loteSelected', JSON.stringify(this.ItemLista));
                if (this.ItemLista == null) {
                    this.ItemLista = [];
                }
                if ((this.ItemLista != null) && (this.ItemLista.length == 0)) {
                    this.mensaje = '<i class=\'material-icons\'>youtube_searched_for</i> UTILICE OTRO FILTRO DE BÚSQUEDA SOBRE <b>' + this.origenCRUD.toUpperCase() + 'S </b>, NO SE HAN CONSEGUIDO REGISTROS';
                }
            }, err => {
                this.cargandoList = false;
                this.ItemLista = [];
                this.jwtUtil.abrirModalErrorParaServicios(err, 'No se pudo consultar el documento', this.router);
            });
    }


    getReceptores() {
        // LLAMADO AL SERVICIO

        this.loading = true;
        var param: any = {}

        if (this.empresaAdministradora) {
            param.receptorID = 0;
        }
        this.consumer.get<any>(WebServices.URL_LIST_CUSTOMER_EMISOR_TERCERO)
            .subscribe(result => {
                this.receptores = [];
                this.receptores = result["thirdReceivers"];
            }, err => {
                this.ItemLista = [];
                this.loading = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo obtener la lista de los emisores", this.router)
            });
    }

    getNameReceptor(id) {
        if (this.receptores == null || this.receptores.length == 0) {
            return 'TODAS';
        }

        let name = this.receptores.filter(value => value.receiverId == id);
        if (name == null || name.length == 0) {
            return 'TODAS';
        }
        return name[0].receiveName;
    }

    generarLote(item) {
        swal({
            title: 'Estas seguro de generar el lote?',
            text: 'Una vez generado el lote, no se podra modificar',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, estoy seguro!',
            cancelButtonText: 'No, espero',
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            buttonsStyling: false
        }).then(() => {
            this.cargandoList = true;
            var params = {
                "id": item.id,
                "rowType": this.type,
            }
            this.consumer.post<any>(WebServices.URL_GENERATE_EMISOR_TERCERO, params)
                .subscribe(result => {
                    this.cargandoList = false;
                    this.realizarBusqueda();
                    swal({
                        title: 'En proceso',
                        text: 'Su lote se esta generando',
                        type: 'success',
                        confirmButtonClass: 'btn btn-success',
                        buttonsStyling: false
                    });
                }, err => {
                    this.cargandoList = false;
                    this.jwtUtil.abrirModalErrorParaServicios(err, 'No se pudo consultar el documento', this.router);
                });
        }, function (dismiss) {
        }).catch(swal.noop);

    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/emisorTerceros/cmp-list-documents/listDocuments.component.ts